import { useTranslation } from 'react-i18next';

import styles from './styles.module.css';

interface SummaryArbitrageProps {
  contractName: string;
  totalReinvested: number;
  totalFees: number;
}
export const SummaryArbitrage: React.FC<SummaryArbitrageProps> = ({ contractName, totalReinvested, totalFees }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.summaryArbitrage}>
      <span className={styles.summaryArbitrageTitle}>{t('summaryArbitrage.title')}</span>
      <hr className={styles.separator} />
      <div className={styles.summaryArbitrageDetails}>
        <div className={styles.summaryArbitrageInfo}>
          <p className={styles.arbitrageTitle}>{t('summaryArbitrage.contract')}</p>
          <span className={styles.arbitrageInfo}>{contractName}</span>
        </div>
        <div className={styles.summaryArbitrageInfo}>
          <p className={styles.arbitrageTitle}>{t('summaryArbitrage.totalReinvested')}</p>
          <span className={styles.arbitrageInfo}>{t('format.currencyFlexible', { value: totalReinvested })}</span>
        </div>
        <div className={styles.summaryArbitrageInfo}>
          <p className={styles.arbitrageTitle}>{t('summaryArbitrage.totalFees')}</p>
          <span className={styles.arbitrageInfo}>{t('format.currencyFlexible', { value: totalFees })}</span>
        </div>
      </div>
    </div>
  );
};
